// TODO: Include defaults (possibly configurable) for the dev environment

import { selectKeys } from "../../frontendlib/utils";

export default class EnvData {
  constructor(envData) {
    this._envData = envData;
  }

  asObject() {
    return this._envData;
  }

  asJSON() {
    return JSON.stringify(this._envData);
  }

  getClickConfig() {
    return this._envData.clickConfig;
  }

  getClickthroughURL() {
    return this.getClickConfig().clickthroughURL.url;
  }

  getClickTrackingURLs() {
    return this.getClickConfig().clickTrackingURLs;
  }

  getExchange() {
    return this._envData.exchange;
  }

  getABTests() {
    return this._envData.abTests;
  }

  hasABTestGroup(abTestGroup) {
    return this._envData.abTests.includes(abTestGroup);
  }

  getAuctionID() {
    return this._envData.impression.auctionID;
  }

  getIsReengagement() {
    return this._envData.isReengagement;
  }

  getCostModel() {
    return this._envData.costModel;
  }

  getTrackingToken() {
    return this._envData.trackingToken;
  }

  // Geo data
  getLatitude() {
    return this._envData.geo.latitude;
  }

  getLongitude() {
    return this._envData.geo.longitude;
  }

  // Device info
  getDeviceIDs() {
    // Exclude IDFA
    return selectKeys(this._envData.device, [
      "idfaSHA1",
      "idfaMD5",
      "androidID",
      "androidIDSHA1",
      "androidIDMD5",
      "googleAID",
      "googleAIDSHA1",
    ]);
  }

  /**
   * Returns an integer of the connection type as defined
   * in rtb.proto
   */
  getDeviceConnectionType() {
    return this._envData.device.connectionType;
  }

  /**
   * Returns a string of the OS version. Example "14.6.2"
   */
  getDeviceOSVersion() {
    return this._envData.device.osVersion;
  }

  getGoogleAID() {
    return this.getDeviceIDs().googleAID;
  }

  getDeviceLanguage() {
    return this._envData.device.normalizedLanguage;
  }

  getDevicePlatform() {
    return this._envData.device.platform;
  }

  getAppStoreData() {
    return this._envData.appStoreData;
  }

  getDeviceIP() {
    return this._envData.device.ip;
  }

  getDeviceModel() {
    return this._envData.device.model;
  }

  // Campaign info
  getCampaignID() {
    return this._envData.campaign.id;
  }

  getCampaignName() {
    return this._envData.campaign.name;
  }

  getCampaignTrackingParams() {
    return this._envData.campaign.params;
  }

  // Creative info
  getCreativeID() {
    return this._envData.creative.id;
  }

  getCreativeWidth() {
    return this._envData.creative.width;
  }

  getCreativeHeight() {
    return this._envData.creative.height;
  }

  getCreativeName() {
    return this._envData.creative.name;
  }

  getCreativeTrackingParams() {
    return this._envData.creative.params;
  }

  getIsRewarded() {
    return this._envData.impression.isRewarded;
  }

  // Source app info
  getSourceAppID() {
    return this._envData.app.id;
  }

  getSourceAppName() {
    return this._envData.app.name;
  }

  // Logging configuration
  getEnableHTMLReturn() {
    return this._envData.loggingConfig.enableHTMLReturn;
  }

  getHTMLReturnDelay() {
    return this._envData.loggingConfig.htmlReturnDelay;
  }

  getEnableLogging() {
    return this._envData.loggingConfig.enableLogging;
  }

  getLoggingEndpoint() {
    return this._envData.loggingConfig.loggingEndpoint;
  }

  getEventTrackingParam() {
    return this._envData.loggingConfig.eventTrackingParam;
  }

  // Creative policy
  getAudioPolicy() {
    return this._envData.creativePolicy.audioPolicy;
  }

  getAddBorder() {
    return this._envData.creativePolicy.addBorder;
  }

  getRussianAgeRating() {
    return this._envData.creativePolicy.russianAgeRating;
  }

  getAnimationDurationLimit() {
    return this._envData.creativePolicy.animationDurationLimit;
  }

  getBlockStrobing() {
    return this._envData.creativePolicy.blockStrobing;
  }

  getBlockNotifications() {
    return this._envData.creativePolicy.blockNotifications;
  }

  getShowChineseWatermark() {
    return this._envData.creativePolicy.showChineseWatermark;
  }

  getUseCustomClose() {
    return this._envData.creativePolicy.useCustomClose;
  }

  getCloseDelay() {
    return this._envData.creativePolicy.closeDelay;
  }

  getShowAdChoices() {
    return this._envData.creativePolicy.showAdChoices;
  }

  getRemoveAdWrapper() {
    return this._envData.creativePolicy.removeAdWrapper;
  }

  getIsStaffDevice() {
    return this._envData.isStaffDevice;
  }

  getCDNUrl() {
    return this._envData.cdnURL;
  }

  getIsInterstitial() {
    return this._envData.isInterstitial;
  }

  getPlatform() {
    return this._envData.platform;
  }

  /**
   * Product View autoclick behavior. Typically, this sends the user to the app
   * store.
   */
  getPvAutoclickBehavior() {
    return this._envData.pvAutoclickBehavior;
  }

  /**
   * Auto viewclick behavior. A viewclick is when we send a click to the MMP
   * without also opening the app store.
   */
  getViewclickBehavior() {
    return this._envData.viewclickBehavior;
  }

  getLastChanceAutoclickBehavior() {
    return this._envData.lastChanceAutoclickBehavior;
  }

  getLastChanceInteractionAutoclickBehavior() {
    return this._envData.lastChanceInteractionAutoclickBehavior;
  }

  /**
   * Liftoff Product View (LOPV) autoclick behavior. A LOPV is a "fake" product
   * view rendered by the creative itself.
   */
  getLopvAutoclickBehavior() {
    return this._envData.lopvAutoclickBehavior;
  }
}



// WEBPACK FOOTER //
// ./src/js/madlib/csp-env/env_data.js